var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralCertificationDoctor = function SvgGeneralCertificationDoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF540F",
    d: "m3 6.75 9.188-5.25 9.187 5.25v10.5l-9.187 5.25L3 17.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.492 16.375 6.5 12.305l1.2-1.222 2.792 2.847 6.184-6.305 1.199 1.222z"
  }))));
};
export default SvgGeneralCertificationDoctor;